import PlatformUtil from './PlatformUtil';
const LEGAL_PATH = '/legal';
export default function getLegalURL() {
    if (PlatformUtil.isApp()) {
        const host = location.protocol === 'http:' ? 'jp.indeed.com' : location.host;
        // To open in web browser, we use 'http' intentionally.
        // http://jp.indeed.com redirects to https://jp.indeed.com
        return `http://${host}${LEGAL_PATH}`;
    }
    return LEGAL_PATH;
}
